
import AepsBankMain from "../../components/aeps-bank-withdraw-reports/AepsBankMain"

export const AEPSBankReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <AepsBankMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}